import React, { useEffect, useRef, useState } from 'react';
import Draggable from 'react-draggable';
import parse from 'html-react-parser';
import styled from 'styled-components';
import ColorPicker from './color_picker';
import {
  getBackgroundWidgetsValue,
  getTextColorValue,
} from './virtual_theme_core';

// Styled component for the root container with dynamic styles
const StyledDraggableComponent = styled.div`
  ${props =>
    props.backgroundWidgets != null && props.backgroundWidgets !== ''
      ? `--background-widgets: ${props.backgroundWidgets};`
      : ''}
  ${props =>
    props.textColor != null && props.textColor !== ''
      ? `--text-color: ${props.textColor};`
      : ''}
`;

const DraggableComponent = ({
  html,
  script,
  parentRef,
  widgetsRef,
  initialX = 0,
  initialY = 0,
  fromTheme = false,
}) => {
  const [position, setPosition] = useState({
    x: 0,
    y: 0,
    currentX: 0,
    currentY: 0,
    width: 0,
    height: 0,
    distanceLeft: 0,
    distanceRight: 0,
    distanceTop: 0,
    distanceBottom: 0,
  });
  const nodeRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [inBounds, setInBounds] = useState(false);
  const [colorChange, setColorChange] = useState(false);
  const [dragged, setDragged] = useState(false);
  const [textColor, setTextColor] = useState({
    hex: '#333',
    rgb: {
      r: 51,
      g: 51,
      b: 51,
      a: 1,
    },
  });
  const [backColor, setBackColor] = useState({
    hex: '#333',
    rgb: {
      r: 51,
      g: 51,
      b: 51,
      a: 1,
    },
  });
  useEffect(() => {
    setBackColor(getBackgroundWidgetsValue(html));
    setTextColor(getTextColorValue(html));
  }, []);

  useEffect(() => {
    const ensureIframeExists = () => {
      let iframe = document.getElementById('workSpaceFrame');
      if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.id = 'workSpaceFrame';
        iframe.style.display = 'none';
        document.body.appendChild(iframe);
      }
      return iframe;
    };

    if (script) {
      const scriptElement = document.createElement('script');
      scriptElement.innerHTML = `
        try {
          (function() { 
            const document = window.parent.document;
            ${script} 
          })();
        } catch (error) {
          console.log('Script execution error:', error);
        }
      `;
      const workspaceFrame = ensureIframeExists();
      if (workspaceFrame) {
        workspaceFrame.contentDocument.body.appendChild(scriptElement);
      }
    }
  }, [script]);

  const handleDrag = (e, data) => {
    if (!dragged) setDragged(true);
    setIsDragging(true);

    if (parentRef.current) {
      const scrollX = window.scrollX || document.documentElement.scrollLeft;
      const scrollY = window.scrollY || document.documentElement.scrollTop;
      console.log(data.node.children);
      const parentRect = parentRef.current.getBoundingClientRect();
      let elementRect = null;
      try {
        elementRect = data.node.children[1].getBoundingClientRect();
      } catch {}
      if (elementRect != '' && elementRect != null) {
        const distanceLeft = elementRect.left - parentRect.left;
        const distanceRight = parentRect.right - elementRect.right;
        const distanceTop = elementRect.top - parentRect.top;
        const distanceBottom = parentRect.bottom - elementRect.bottom;
        const isWithinParent =
          elementRect.top >= parentRect.top &&
          elementRect.left >= parentRect.left &&
          elementRect.bottom <= parentRect.bottom &&
          elementRect.right <= parentRect.right;

        setInBounds(isWithinParent);

        setPosition({
          x: Math.round(elementRect.left - parentRect.left),
          y: Math.round(elementRect.top - parentRect.top),
          currentX: elementRect.left + scrollX,
          currentY: elementRect.top + scrollY,
          width: elementRect.width,
          height: elementRect.height,
          distanceLeft: Math.round(distanceLeft),
          distanceRight: Math.round(distanceRight),
          distanceTop: Math.round(distanceTop),
          distanceBottom: Math.round(distanceBottom),
        });

        console.log(elementRect.left, elementRect.top)
      }
    } else {
      setPosition({ x: data.x, y: data.y });
    }
  };

  return (
    <StyledDraggableComponent
      ref={nodeRef}
      backgroundWidgets={
        backColor != null
          ? `rgba(${backColor.rgb.r}, ${backColor.rgb.g}, ${backColor.rgb.b}, ${backColor.rgb.a})`
          : null
      }
      textColor={
        textColor != null
          ? `rgba(${textColor.rgb.r}, ${textColor.rgb.g}, ${textColor.rgb.b}, ${textColor.rgb.a})`
          : null
      }
    >
      {dragged ? (
        <div
          style={{
            position: 'absolute',
            left: position.x + position.width,
            top: position.y,
            zIndex: 99999,
            display: 'flex',
            flexDirection: 'column',
            gap: '5px',
            justifyContent: 'flex-start',
          }}
        >
          <ColorPicker color={backColor} onChange={setBackColor} text={'фон'} />
          <ColorPicker
            color={textColor}
            onChange={setTextColor}
            text={'текст'}
          />
        </div>
      ) : null}
      
      <Draggable
        nodeRef={nodeRef}
        onDrag={handleDrag}
        onStop={() => setIsDragging(false)}
        defaultPosition={{ x: initialX, y: initialY }}
        
      >
        {parse(html)}
      </Draggable>
      {isDragging && (
        <>
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: fromTheme ? position.x : position.currentX,
              width: '1px',
              height: '100%',
              backgroundColor: 'red',
              zIndex: 99999,
            }}
          />
          <div
            style={{
              position: 'absolute',
              left: 0,
              top: fromTheme ? position.y : position.currentY,
              width: '100%',
              height: '1px',
              backgroundColor: 'red',
              transform: 'translateY(-100%)',
              zIndex: 99999,
            }}
          />
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: fromTheme
                ? position.x + position.width
                : position.currentX + position.width,
              width: '1px',
              height: '100%',
              backgroundColor: 'red',
              transform: 'translateX(-100%)',
              zIndex: 99999,
            }}
          />
          <div
            style={{
              position: 'absolute',
              left: 0,
              top: fromTheme
                ? position.y + position.height
                : position.currentY + position.height,
              width: '100%',
              height: '1px',
              backgroundColor: 'red',
              transform: 'translateY(-100%)',
              zIndex: 99999,
            }}
          />
        </>
      )}
      {inBounds && (
        <div
          style={{
            position: 'absolute',
            top: `${fromTheme ? position.y - 20 : position.currentY - 20}px`,
            left: `${fromTheme ? position.x - 20 : position.currentX - 20}px`,
            zIndex: 99999,
            color: 'red',
          }}
        >
          x: {position.x}, y: {position.y}
        </div>
      )}
    </StyledDraggableComponent>
  );
};

export default DraggableComponent;
